import { FC } from 'react';

import { useElementSize } from '~/shared/hooks/useElementSize';
import { usePasswordRecovery } from '../../hooks/usePasswordRecovery';

import { Container } from './styles';

import { StepTwo } from './StepTwo';
import { StepThree } from './StepThree';
import { StepOne } from './StepOne';
import { StepFour } from './StepFour';

export const PasswordRecoverySteps: FC = () => {
  const { currentStep } = usePasswordRecovery();

  const [containerRef, { width: containerWidth }] = useElementSize();

  return (
    <Container
      ref={containerRef}
      width={containerWidth}
      currentStep={currentStep}
    >
      <div>
        <StepOne />

        <StepTwo />

        <StepThree />

        <StepFour />
      </div>
    </Container>
  );
};
